/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { HistoryRecordDateUpdate } from '../model/historyRecordDateUpdate';
import { HistoryRecordDelete } from '../model/historyRecordDelete';
import { HistoryRecordFieldValueUpdate } from '../model/historyRecordFieldValueUpdate';
import { HistoryRecordFutureValueReplace } from '../model/historyRecordFutureValueReplace';
import { PaginatedHistoryChangeItemList } from '../model/paginatedHistoryChangeItemList';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class UnifiedChildHistoryService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Unified view of all history change items for a child across all related models.
     * @param body 
     * @param childUuid Child UUID (required)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public unifiedChildHistoryApplyFutureValueCreate(body: HistoryRecordFutureValueReplace, childUuid: string, observe?: 'body', reportProgress?: boolean): Observable<{ [key: string]: any; }>;
    public unifiedChildHistoryApplyFutureValueCreate(body: HistoryRecordFutureValueReplace, childUuid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<{ [key: string]: any; }>>;
    public unifiedChildHistoryApplyFutureValueCreate(body: HistoryRecordFutureValueReplace, childUuid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<{ [key: string]: any; }>>;
    public unifiedChildHistoryApplyFutureValueCreate(body: HistoryRecordFutureValueReplace, childUuid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling unifiedChildHistoryApplyFutureValueCreate.');
        }

        if (childUuid === null || childUuid === undefined) {
            throw new Error('Required parameter childUuid was null or undefined when calling unifiedChildHistoryApplyFutureValueCreate.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (childUuid !== undefined && childUuid !== null) {
            queryParameters = queryParameters.set('child_uuid', <any>childUuid);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<{ [key: string]: any; }>('post',`${this.basePath}/unified-child-history/apply-future-value/`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Unified view of all history change items for a child across all related models.
     * @param body 
     * @param childUuid Child UUID (required)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public unifiedChildHistoryDeleteRecordCreate(body: HistoryRecordDelete, childUuid: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public unifiedChildHistoryDeleteRecordCreate(body: HistoryRecordDelete, childUuid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public unifiedChildHistoryDeleteRecordCreate(body: HistoryRecordDelete, childUuid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public unifiedChildHistoryDeleteRecordCreate(body: HistoryRecordDelete, childUuid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling unifiedChildHistoryDeleteRecordCreate.');
        }

        if (childUuid === null || childUuid === undefined) {
            throw new Error('Required parameter childUuid was null or undefined when calling unifiedChildHistoryDeleteRecordCreate.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (childUuid !== undefined && childUuid !== null) {
            queryParameters = queryParameters.set('child_uuid', <any>childUuid);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/unified-child-history/delete-record/`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Get combined history for a child across all models (profile, address, spz_recommendation, support_measures). Results ordered by date DESC, then by model name.
     * @param childUuid Child UUID (required)
     * @param includeModels Comma-separated model names to include. Valid values: child_profile, child_profile_address, child_spz_recommendation, child_support_measures. Default: all
     * @param limit Number of results to return per page.
     * @param offset The initial index from which to return the results.
     * @param search Search by field_name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public unifiedChildHistoryList(childUuid: string, includeModels?: string, limit?: number, offset?: number, search?: string, observe?: 'body', reportProgress?: boolean): Observable<PaginatedHistoryChangeItemList>;
    public unifiedChildHistoryList(childUuid: string, includeModels?: string, limit?: number, offset?: number, search?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaginatedHistoryChangeItemList>>;
    public unifiedChildHistoryList(childUuid: string, includeModels?: string, limit?: number, offset?: number, search?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaginatedHistoryChangeItemList>>;
    public unifiedChildHistoryList(childUuid: string, includeModels?: string, limit?: number, offset?: number, search?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (childUuid === null || childUuid === undefined) {
            throw new Error('Required parameter childUuid was null or undefined when calling unifiedChildHistoryList.');
        }





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (childUuid !== undefined && childUuid !== null) {
            queryParameters = queryParameters.set('child_uuid', <any>childUuid);
        }
        if (includeModels !== undefined && includeModels !== null) {
            queryParameters = queryParameters.set('include_models', <any>includeModels);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PaginatedHistoryChangeItemList>('get',`${this.basePath}/unified-child-history/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Unified view of all history change items for a child across all related models.
     * @param body 
     * @param childUuid Child UUID (required)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public unifiedChildHistoryUpdateDateCreate(body: HistoryRecordDateUpdate, childUuid: string, observe?: 'body', reportProgress?: boolean): Observable<{ [key: string]: any; }>;
    public unifiedChildHistoryUpdateDateCreate(body: HistoryRecordDateUpdate, childUuid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<{ [key: string]: any; }>>;
    public unifiedChildHistoryUpdateDateCreate(body: HistoryRecordDateUpdate, childUuid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<{ [key: string]: any; }>>;
    public unifiedChildHistoryUpdateDateCreate(body: HistoryRecordDateUpdate, childUuid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling unifiedChildHistoryUpdateDateCreate.');
        }

        if (childUuid === null || childUuid === undefined) {
            throw new Error('Required parameter childUuid was null or undefined when calling unifiedChildHistoryUpdateDateCreate.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (childUuid !== undefined && childUuid !== null) {
            queryParameters = queryParameters.set('child_uuid', <any>childUuid);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<{ [key: string]: any; }>('post',`${this.basePath}/unified-child-history/update-date/`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Unified view of all history change items for a child across all related models.
     * @param body 
     * @param childUuid Child UUID (required)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public unifiedChildHistoryUpdateFieldCreate(body: HistoryRecordFieldValueUpdate, childUuid: string, observe?: 'body', reportProgress?: boolean): Observable<{ [key: string]: any; }>;
    public unifiedChildHistoryUpdateFieldCreate(body: HistoryRecordFieldValueUpdate, childUuid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<{ [key: string]: any; }>>;
    public unifiedChildHistoryUpdateFieldCreate(body: HistoryRecordFieldValueUpdate, childUuid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<{ [key: string]: any; }>>;
    public unifiedChildHistoryUpdateFieldCreate(body: HistoryRecordFieldValueUpdate, childUuid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling unifiedChildHistoryUpdateFieldCreate.');
        }

        if (childUuid === null || childUuid === undefined) {
            throw new Error('Required parameter childUuid was null or undefined when calling unifiedChildHistoryUpdateFieldCreate.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (childUuid !== undefined && childUuid !== null) {
            queryParameters = queryParameters.set('child_uuid', <any>childUuid);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<{ [key: string]: any; }>('post',`${this.basePath}/unified-child-history/update-field/`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
